import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getFilteredUsersApi } from "api/user";




const initialState = {
    data: [],


};

export const getUserAPI = createAsyncThunk("getUserAPI", async (thunkAPI) => {
    try {

        const res = await getFilteredUsersApi();
        return res.data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }

})



const user = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUserData: (state, action) => {
            state.data = action.payload;
        },
        getUserFetchData: (state, action) => {
            state.data = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserAPI.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getUserAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.data = action.payload;
            })
            .addCase(getUserAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
                state.authUser = null;
            })

    }
});

export const { setUserData, getUserFetchData } = user.actions;
export default user.reducer;